export const API_KEY_LENGTH = 32;
export const BALANCE_REQUEST_INTERVAL = 2000;
export const BALANCE_REQUEST_DURATION = 30000;

export const generateTableHead = (access) => [
  { title: 'Provider', access: true, class: 'p-l', attrs: { style: { width: '45%' } } },
  { title: 'Alias', access: true },
  { title: '', attrs: { style: { width: '3%' } }, access: true },
  { title: 'Balance', access: true, code: 'balance' },
  { title: '', access: access?.providers_edit },
].filter((item) => item.access);

export const generateTableBody = (item, access) => [
  { type: 'name', value: item.name, class: 'p-l', access: true },
  { type: 'alias', value: item.alias, access: true },
  { type: 'event_low_balance', value: item?.event_low_balance, access: true },
  { type: 'balance', value: item?.balance, access: true },
  { type: 'actions', value: '', class: 'p-r', access: access?.providers_edit },
].filter((item) => item.access);

export const toFixed2 = (stringNumber) => {
  if (stringNumber === '0' || stringNumber === 0) return '0.00';
  return stringNumber.toString().match(/^-?\d+(?:\.\d{0,2})?/)?.[0];
};
